import React, { useState, useContext } from 'react';
import axios from 'axios';
import { ToastContainer, toast } from 'react-toastify';
import styles from './OrderReview.module.sass';
import 'react-toastify/dist/ReactToastify.css';
import TextInput from '../../TextInput';
import { Coupon } from '../../../models/_models';
import { CustomerContext } from '../../../contexts/CustomerContext';
import Button from '../../Button/v2';
import { Cart } from '../../../models';

const CouponForm = ({ appointments }) => {
  const [code, setCode] = useState('');
  const [loading, setLoading] = useState(false);
  const { customer, setCustomer } = useContext(CustomerContext);

  const cartKey = appointments ? 'apptCart' : 'cart';
  const cart = customer[cartKey];

  const handleSubmit = async (e) => {
    e.preventDefault();

    setLoading(true);

    if (!code) return;

    const message = await axios({
      baseURL: '',
      method: 'get',
      url: `/coupons/for_cart?cart_id=${customer[cartKey].id}&code=${(code || '').toUpperCase()}`,
    })
      .then((res) => res.data.message);

    if (message) {
      toast.error(`Can't process ${code}. ${message}`, { autoClose: false });
      setLoading(false);
      return;
    }

    const coupon = await Coupon
      .where({ code: (code || '').toUpperCase() })
      .first()
      .then((res) => res.data);

    const dbCart = await Cart
      .where({ for_email: [cart.id, customer.email], purchased: false })
      .first()
      .then((res) => res.data);

    dbCart.email = customer.email;
    dbCart.coupon = coupon;
    dbCart.couponId = coupon.id;

    await dbCart.save();

    setCustomer({ ...customer, ...dbCart });
    toast('Coupon was successfully applied to your cart!');

    setTimeout(() => {
      window.location.reload();
    }, 1000);
  };

  return (
    <>
      <form className={styles.couponForm} onSubmit={handleSubmit}>
        <TextInput fullWidth onChange={(e) => setCode(e.target.value)} val={code} placeholder="Enter Coupon" />
        <Button disabled={loading || !code} variant="submit" type="submit">Apply</Button>
      </form>
      <ToastContainer
        position="bottom-right"
      />
    </>
  );
};

export default CouponForm;
